import React from 'react';
import { createUseStyles } from 'react-jss';
import PropTypes from 'prop-types';

const useStyles = createUseStyles({
  element: props => ({
    ...props
  })
});

const Element = ({
  type,
  className,
  style,
  children,
  onClick,
  attrs,
  ...props
}) => {
  const classes = useStyles(props);
  const Tag = type;
  return (
    <Tag
      className={`${classes.element} ${className}`}
      onClick={onClick}
      style={style}
      {...attrs}
    >
      {children}
    </Tag>
  );
};

/**
 * Prop-types of the Component
 */
Element.propTypes = {
  type: PropTypes.node.isRequired | PropTypes.string.isRequired
};

/**
 * Some default props to the Component
 */
Element.defaultProps = {
  type: 'div'
};

export default Element;
